module.exports = __webpack_public_path__ + "img/creature.51855f40.jpg";